import {
  getFontCss,
  Popup,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { useDispatch } from 'react-redux'
import TestId from 'src/components/TestId/TestId'
import Trns from 'src/localization/Trns'
import { createSetIsAttachReceiptsExpenseReportPopupOpen } from 'src/redux/actions/app.actions'
import { css } from 'styled-components'

const AttachReceiptsExpenseReportPopup: React.FC = (): React.ReactElement => {
  const dispatch = useDispatch()

  const closePopup = (): void => {
    dispatch(createSetIsAttachReceiptsExpenseReportPopupOpen(false))
  }

  return (
    <Popup
      onClickClose={closePopup}
      showCloseButton
      css={css`
        display: flex;
        position: relative;
      `}
    >
      <div
        css={css`
          width: 100%;
          display: flex;
          flex-direction: column;
        `}
      >
        <span
          css={css`
            ${getFontCss(
              32,
              styleConstants.colors.red,
              styleConstants.fontFamilies.medium,
            )};
            margin-bottom: 30px;
          `}
        >
          <Trns source={'Attach Receipts'} />
        </span>
        <span
          css={css`
            ${getFontCss(
              16,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};
            margin-bottom: 20px;
          `}
        >
          <TestId testId={'missingReceiptMessage'}>
            <Trns
              source={
                'Looks like there are receipts missing from your expenses.'
              }
            />
          </TestId>
        </span>
        <span
          css={css`
            ${getFontCss(
              16,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.medium,
            )};
          `}
        >
          <Trns source={'Please attach your receipts to submit your report.'} />
        </span>
      </div>
    </Popup>
  )
}

export default AttachReceiptsExpenseReportPopup
